/**
 * Módulo RBAC (Role-Based Access Control).
 * Única fuente de verdad para roles, permisos y comprobaciones de acceso.
 */
import getCurrentRole from './getCurrentRole';
import { getPermissions, loadPermissions } from './permissions';

export { ROLE_IDS, ROLES } from './constants';
export { PERMISSIONS, getPermissions, loadPermissions } from './permissions';
export { default as getCurrentRole } from './getCurrentRole';

/**
 * Indica si el usuario actual tiene el role indicado.
 * @param {number} roleId - ID del role (usar ROLE_IDS)
 * @returns {boolean}
 */
export const hasRole = (roleId) => getCurrentRole() === roleId;

/**
 * IMT staff (role > 0: Super Admin, Agent y resto de roles internos)
 * puede cargar/reemplazar/borrar documentos de cliente.
 * El cliente (role 0 / complete-info) no puede borrar ni sustituir archivos en B2.
 */
export const canManageClientDocuments = () => {
  if (canAccess("client_documents_manage")) return true;
  return getCurrentRole() > 0;
};

/**
 * Indica si el usuario actual puede acceder al permiso dado.
 * @param {string} permissionKey - Clave de PERMISSIONS (ej: 'users', 'payments')
 * @returns {boolean}
 */
export const canAccess = (permissionKey) => {
  const perms = getPermissions();
  if (perms == null || typeof perms !== 'object') return false;
  const role = getCurrentRole();
  const allowed = perms[permissionKey];
  if (allowed === undefined) return false;
  if (allowed === null) return true; // acceso para todos
  return allowed.includes(role);
};

/**
 * Mantener compatibilidad con código que usa getPermissionRole().
 * @deprecated Usar getCurrentRole() o canAccess() según el caso.
 */
export const getPermissionRole = getCurrentRole;



// WEBPACK FOOTER //
// ./src/rbac/index.js